import React from 'react';
import styled from 'styled-components';
import { MdDragIndicator } from 'react-icons/md';
import { DeleteBtn } from '@/features/editor/widgets/custom-widget/loading-section/shared/delete-btn';
import { MoreFilters } from '@/features/editor/widgets/custom-widget/loading-section/shared/more-filters';

type Props = {
  onClick?: () => void;
  slotNum?: number;
  onDelete?: () => void;
  onMoreFilters?: () => void;
  filterLen?: number;
  draggableAttributes?: any;
  draggableListeners?: any;
};

export function SlotActions({
  onClick,
  slotNum,
  onMoreFilters,
  filterLen,
  onDelete,
  draggableAttributes,
  draggableListeners,
}: Props) {
  const isClickable = typeof onClick !== `undefined`;
  return (
    <ActionsWrapper>
      <MoreFilters
        isVisible={!isClickable}
        filterLen={filterLen}
        onMoreFilters={onMoreFilters}
      />
      <DeleteBtn
        margin="2px 0.5rem -2px"
        slotNum={slotNum}
        onDelete={onDelete}
      />
      <MdDragIndicator
        {...draggableAttributes}
        {...draggableListeners}
        size={25}
        cursor="grab"
        color="#798794"
      />
    </ActionsWrapper>
  );
}

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #97979740;
  width: 100%;
  margin-top: 5%;
  padding-top: 1rem;

  && > svg:focus {
    outline: none;
  }
  && > svg:hover * {
    color: black;
  }
`;
